/**
 * サービスの基底クラス
 */
export default class BaseService {
	/**
	 * コンストラクタ
	 * @param token アクセストークン
	 */
	constructor(protected token?: string) {
		this.token = token;
	}

	/**
	 * ベース URL を含んだ URL を返します。
	 * @param path パス
	 * @returns URL
	 */
	protected url(path: string) {
		return `${process.env.NEXT_PUBLIC_API_BASE_URL}/api${path}`;
	}
}
